export enum DatapointType {
  String = 'string',
  Date = 'date',
  Datetime = 'datetime',
  Number = 'number',
  Enum = 'enum',
}
